/**
 * 数据监控 监控查询
 */
<template>
<div style="display: flex">
  <el-card class="box-card" style="width: 300px; margin-right: 10px">
					   <div slot="header" class="clearfix">
					      <span>项目</span>
					    </div>
			        <el-scrollbar style="height: 640px">
			          <el-tree
			            ref="tree"
			            :data="treeData"
			            node-key="FItemID"
			            :expand-on-click-node="false"
			            highlight-current
			            @node-click="nodeClick"
			          ></el-tree>
			        </el-scrollbar>
			      </el-card>
				  <el-dialog title="复制类" :visible.sync="dialogFormVisible">
					<el-form :model="form">
						<el-form-item label="项目" :label-width="formLabelWidth">
						<el-select-tree :options="treeData" :value="value" @getValue="getSelectedValue"></el-select-tree>
						</el-form-item>
						<el-form-item label="明细类" :label-width="formLabelWidth">
						<!-- <el-select-doubletree :options="resourcedata" :multiple="multiple" :valueMultiple="valueMultiple" @getValue="getSelectedValues"></el-select-doubletree> -->
						<el-select v-model="form.region" multiple placeholder="请选择" style="width: 16rem"> 
                    <el-option :value="treeDataValue" style="height: auto">
                        <el-tree
                            ref="tree"
                            :data="resourcedata"
                            default-expand-all
                            node-key="id"
                            :props="defaultProps"
                            @node-click="handNodeClick"
                        />
                    </el-option>
                </el-select>
						<!-- <el-select v-model="form.resource" placeholder="请选择明细类">
							<el-option v-for="item in resourcedata" :key="item.FItemID" :value-key="item.FItemID"
					        		:label="item.FName" :value="item.FItemID">
					        		<span style="float: right; color: #8492a6; font-size: 13px">{{item.FName}}
					        		</span>
					        	</el-option>
						</el-select> -->
						</el-form-item>
					</el-form>
					<div slot="footer" class="dialog-footer">
						<el-button @click="dialogFormVisible = false">取 消</el-button>
						<el-button type="primary" @click="Nodesure">确 定</el-button>
					</div>
					</el-dialog>
				  <el-card class="box-card" style="width: 300px; margin-right: 10px" v-if='showtable'>
					  <div slot="header" class="clearfix">
					     <span>模块明细类</span>
					   </div>
					 <el-tooltip class="item" effect="dark" content="新增大类" placement="top-start">
					  <el-button @click="navMenuInsert() " size="small" type="primary" icon="el-icon-plus" circle plain>
					  </el-button>
					 </el-tooltip>
					  <el-tooltip class="item" effect="dark" content="复制类" placement="top-start">
					  <el-button @click="navCopy() " size="small" type="primary" icon="el-icon-download" circle plain>
					  </el-button>
					 </el-tooltip>
					  <!-- <el-tooltip class="item" effect="dark" content="修改" placement="top-start">
					  <el-button size="small" type="primary" icon="el-icon-edit" circle plain @click='uptree'>
					  </el-button>
					  </el-tooltip> -->
				    <el-scrollbar style="height: 640px;margin-top: 10px;">
				    <el-tree
				      :props="props"
				      :load="loadNode"
				       lazy
					   ref="lazytree"
				      show-checkbox
				      @check-change="handleCheckChange"
					  @check="checkBox">
					   <span class="custom-tree-node" slot-scope="{ node, data }">
						<span>{{ node.label }}</span>
						<span>
						<el-button
							type="text"
							size="mini"
							@click="() => append(data)">
							添加下级
						</el-button>
						<el-button
							type="text"
							size="mini"
							@click="() => reupdate(node, data)">
							修改
						</el-button>
						<el-button
							type="text"
							size="mini"
							@click="() => remove(node, data)">
							删除
						</el-button>
						</span>
					</span>
				    </el-tree>
				    </el-scrollbar>
				  </el-card>
			      <el-card class="box-card" style="flex: 1"> 
				    <div slot="header" class="clearfix" v-if='showtable'>
				   <span>预算</span>
				 </div>
					<div v-if='showtable'>
						<el-button v-for="(item, index) in btnArray" :key="item.id"
							:class="{ active: currentSorts == index }" @click="giveCharData1(index)" size="small">
							{{ item.text }}
						</el-button>
						<div  v-if='currentSorts==0'>
								<el-upload ref="upload"
						   :show-file-list="false"
						   :on-change="uploadByJsqd"
						   :auto-upload="false"
						   :limit="1"
						   :action="'/api/xxxx/xxxxxxxxxxxxx/'"
						   accept=".xlsx"
						   style="float:left;margin-left:5px;">
					<el-button type="small"
					style="float:left;margin-left:5px;"
							   class=".el-dropdown-menu__item i"
							   slot="trigger"
							   icon="el-icon-download">导入</el-button>
							  
				</el-upload> 

							<el-button type="primary" style="float:right;margin-left:2px" @click="unstatus()">反审核</el-button>
							<el-button type="primary" style="float:right" @click="status()">审核</el-button>
							<el-select v-model="treesID" filterable placeholder="请选择" size="medium" style="float:right;margin-right:5px;">
					        	<el-option v-for="item in ctreesdata" :key="item.FItemID" :value-key="item.FItemID"
					        		:label="item.FName" :value="item.FItemID">
					        		<span style="float: right; color: #8492a6; font-size: 13px">{{item.FName}}
					        		</span>
					        	</el-option>
					        </el-select>
						 <el-table ref="multipleTable" :data="listData.slice((currentPage - 1) * pageSize, currentPage * pageSize)" border id="el-table" highlight-current-row    v-loading="loading" show-summary 
						 element-loading-text="拼命加载中" style="width: 100%;margin-top: 10px;" class="demo-ruleForm">
						<el-table-column align="center" sortable prop="LName" label="部件名称" class="demo-ruleForm">
							<template slot-scope="scope">
								<span >
									<el-input size="small" v-model="scope.row.LName" :controls="false" :disabled='scope.row.FStatus==1'>
									</el-input>
								</span>
							</template>
						</el-table-column>
						<el-table-column align="center" sortable prop="LMoney" label="预算金额" class="demo-ruleForm">
							<template slot-scope="scope">
								<span class="demo-ruleForm">
									<el-input-number size="small" v-model="scope.row.LMoney" :precision="2" :disabled='scope.row.FStatus==1'
										:controls="false">
									</el-input-number>
								</span>
							</template>
						</el-table-column>
					<el-table-column
						fixed="right"
						label="操作"
						width="100">
					<template slot-scope="scope">
						<el-button @click="spear(scope.row,1)" type="text" size="small" :disabled='scope.row.FStatus==1'>修改</el-button>
						<el-button @click="spear(scope.row,2)" type="text" size="small" :disabled='scope.row.FStatus==1'>删除</el-button>
					</template>
					</el-table-column>
						</el-table>
						<div class="block">
							<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
								:current-page="currentPage" :page-sizes="[5,10,15,20]" :page-size="pageSize"
								layout="total, sizes, prev, pager, next, jumper" :total="listData.length">
							</el-pagination>
						</div>
					    </div>
					<div  v-if='currentSorts==1'>
						<el-button type="primary" style="float:right;margin-right:5px;" @click="insert()">保存</el-button>
						<el-select v-model="treeID" filterable placeholder="请选择" size="medium" style="float:right;margin-right:5px;">
					        	<el-option v-for="item in ctreedata" :key="item.FItemID" :value-key="item.FItemID"
					        		:label="item.FName" :value="item.FItemID">
					        		<span style="float: right; color: #8492a6; font-size: 13px">{{item.FName}}
					        		</span>
					        	</el-option>
					        </el-select>
						<!-- <el-tooltip class="item" effect="dark" content="新增行" placement="top-start" style="margin-top:5px">
						<el-button @click="naadd() " size="small" type="primary" icon="el-icon-plus" circle plain>
						</el-button>
						</el-tooltip> -->
			           <el-table ref="multipleTable" :data="listSData.slice((currentPage - 1) * pageSize, currentPage * pageSize)" border id="el-table" highlight-current-row    v-loading="loading" show-summary 
						 element-loading-text="拼命加载中" style="width: 100%;margin-top: 10px;" class="demo-ruleForm">
						  <el-table-column align="center" width="90" >
							<el-tooltip class="item" effect="dark" content="新增行" placement="top-start" style="margin-top:5px">
						<el-button @click="naadd() " size="small" type="primary" icon="el-icon-plus" circle plain>
						</el-button>
						</el-tooltip>
						<el-tooltip class="item" effect="dark" content="删除行" placement="top-start" style="margin-top:5px">
						<el-button @click="adelete(scope.row,scope.$index) " size="small" type="danger" icon="el-icon-delete" circle plain>
						</el-button>
						</el-tooltip>
						</el-table-column>
						<el-table-column align="center" sortable prop="Actual" label="部件名称" >
								<template slot-scope="scope" >
								<span>
									<el-input size="small" v-model="scope.row.Actual" :controls="false">
									</el-input>
								</span>
							</template>
						</el-table-column>
						<el-table-column align="center" sortable prop="Nominal" label="预算金额">
							<template slot-scope="scope" >
								<span >
									<el-input-number size="small" v-model="scope.row.Nominal" :precision="2"
										:controls="false">
									</el-input-number>
								</span>
							</template>
						</el-table-column>
						</el-table>
						<div class="block">
							<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
								:current-page="currentPage" :page-sizes="[5,10,15,20]" :page-size="pageSize"
								layout="total, sizes, prev, pager, next, jumper" :total="listSData.length">
							</el-pagination>
						</div>
						</div>
						<el-row :gutter="20" style="margin-top: 10px">
					</el-row>
				  </div>
		        </el-card>
                </div>      			 
</template>
<script>
import {
		deptList,
		deptSave,
		deptDelete,
		login,
		GetLB,
		accountset,
		LinkQueryApp,
		LinkUpNextApp,
		OperateBill
	} from '../../api/userMG'
	import Pagination from '../../components/Pagination'
	import axios from 'axios';
	import FileSaver from 'file-saver'
	import XLSX from 'xlsx'
	import elSelectTree from './el-select-tree.vue'
	
export default {
	components: { 
		elSelectTree,
    },
data() {
      return {
		multiple: true,
        courseID: '',
		labId: '',
		iconList: [],
		formLabelWidth: '120px',
		treeData: [
		],
		defaultProps: {
                children: "children",
                label: "name",
			},
        treeDataValue: "",
		value:'',
		valueMultiple:[],
		fileList: [],
		dialogFormVisible: false,
		regiondata:[],
		resourcedata:[],
		reallata:[],
		form: {
          name: '',
          region:[],
          date1: '',
          date2: '',
          delivery: false,
          type: [],
          resource: '',
          desc: ''
        },
		props: {
				label: 'name',
				children: 'zones'
			},
		addform: {
			LCode: '',
			LItemID: '',
			LLevel: '',
			region: '',
		},
		count: 1,
		btnArray: [{
				id: "1",
				text: "预算查看"
			}, {
				id: "2",
				text: "预算录入"
			}
		],
		itemdate:[],
		currentSorts:0,
		showtable:false,
		listSData:[],
		listData:[],
		currentPage:1,
		pageSize:10,
		projectID:'',
		navMenuAdd:false,
		serice:[],
		nodedata:'',
		resolvedata:'',
		loading: true,
		check:'',
		checktreedata:'',
		treeID:'',
		ctreedata:[],
		treesID:'',
		ctreesdata:[],
		v_str_AccountID:'154'
            }
			},
		created() {
			this.getdata()
		},
		mounted() {
		   // this.initPic()
		},
		methods: {
			adelete(row,index){
               //console.log(row,index)
			   var new_arr = this.listSData.splice(index, 1)
			},
			getSelectedValue(value) {
            console.log(value)
			let phems = {
				v_str_AccountID: this.v_str_AccountID,
				jsSQL: "{\"SQL\":[{\"select\":\"select * from YP_module where FProjectID  ='"+value.id+"' and FParentID ='0' or FParentID in (select FItemID from YP_module where FProjectID  ='"+value.id+"' and FParentID='0') \"}]}"
				}
				login(phems).then(data => {
				   let arr= data.Data.Table
				   this.reallata=arr
				   this.resourcedata=this.convert(arr)
				})
			
        },
      //文件发生改变就会触发的事件
      uploadByJsqd(file) {
       var reader = new FileReader(); //启动读取指定的File 内容
	reader.readAsArrayBuffer(file.raw); //当读取操作完成时,会触发一个 load 事件,从而可以使用 reader.onload 属性对该事件进行处理。
	console.log(file)
	reader.onload = e => {        //获取文件数据
		const data = e.target.result; //XLSX读取文件
		const wb = XLSX.read(data, { type: "array" });  //获取第一张表
		const wsname = wb.SheetNames[0];
		const ws = wb.Sheets[wsname];
		var result = XLSX.utils.sheet_to_json(ws, { header: 1 });
		this.$refs.upload.clearFiles(); //清除当前 files
		if (result.length < 1503) {
			this.dataDetail(result);
		} else {
			this.$message("每次导入数据最多1500条");
		}
		return result;
	   };
      },
	  async dataDetail(result) {
		  console.log(result)
		   let Data ='';
		  for(let i=1;i<result.length;i++){
			  let item=result[i]
			  let phems = {
				v_str_AccountID: this.v_str_AccountID,
				jsSQL: "{\"SQL\":[{\"select\":\"select * from YP_module where FProjectID  ='"+this.projectID+"' and FName ='"+item['2']+"'; select * from YP_module where FProjectID  ='"+this.projectID+"' and FName ='"+item['0']+"' ;select * from YP_module where FProjectID  ='"+this.projectID+"' andFName ='"+item['1']+"'\"}]}"
				}
			let res= await login(phems)
			if(res.Data.Table.length>0&&res.Data.Table1.length>0&&res.Data.Table2.length>0){
				let amq=res.Data.Table[0]
			    let phes = {
				v_str_AccountID: this.v_str_AccountID,
				jsSQL: "{\"SQL\":[{\"insert\":\"insert into YP_budget (LName,LMoney,LModuleID) values ('"+item['3']+"','"+item['4']+"','"+amq.FItemID+"')  \"}]}"
				}
			   let rem= await login(phes)
			   if(rem.Result=='Y'){
				this.$message({
							type: 'success',
							message: '导入成功'
						});
			}else{
				this.$message({
							type: 'error',
							message: '导入失败'
						});
			}
			}else{
				if(res.Data.Table.length==0){
					this.$message({
							type: 'error',
							message: '当前下面没有该2级分类，请添加'
						});

				}else if(res.Data.Table1.length==0){
					this.$message({
							type: 'error',
							message: '当前下面没有该大类，请添加'
						});
				}else if(res.Data.Table1.length==0){
                         this.$message({
							type: 'error',
							message: '当前下面没有该1级分类，请添加'
						});
				}
				
			}
		  }
	  },
	  navCopy(){
		  this.dialogFormVisible=true
	  },
	  // 点击树节点
        handNodeClick(data, node, nodeData){
            // select 单选
            // select 多选（判重后添加到选择结果数组中）
            this.treeDataValue = data
            let num = 0;
            this.form.region.forEach(item => {
                item == data.name ? num++ : num;
            })
            if(num == 0) {
                this.form.region.push(data.name)
            }
        },
async Nodesure(){
	console.log(this.form.region) 
	let Data = this.form.region.map(
		item => this.reallata.filter(i => {if(i.name==item){ return  i}})[0]
		);
		//Data.forEach(async item=>{
			for(let i=0;i<Data.length;i++){
				let item=Data[i];
				if(item.FParentID=='0'){
              let pom={
		        v_str_AccountID: this.v_str_AccountID,
				jsSQL: "{\"SQL\":[{\"select\":\"select * from YP_module where FProjectID='"+this.projectID+"' and FName='"+item.FName+"' \"}]}"
				  }
				  //查询是否存在该父项
				  let rem=await login(pom)
				  let arr=rem.Data.Table;
				  console.log(arr)
				  if(arr.length>0){

				  }else{
                   let pop={
					v_str_AccountID: this.v_str_AccountID,
					jsSQL: "{\"SQL\":[{\"insert\":\"insert into YP_module (FProjectID,FParentID,FName) select  '"+this.projectID+"','0',FName from YP_module where FItemID= '"+item.FItemID+"'  \"}]}"
		          }
				  let restu=await login(pop)
				  console.log(restu)
				  }
			}else{
				let pom={
		        v_str_AccountID: this.v_str_AccountID,
				jsSQL: "{\"SQL\":[{\"select\":\"select * from YP_module where FProjectID='"+this.projectID+"' and FName='"+item.FName+"';select * from YP_module where FProjectID='"+this.projectID+"' and FName =(select FName from YP_module where FItemID='"+item.FParentID+"') \"}]}"
				  }
				  //查询是否存在该物和父项
				  let rem=await login(pom)
				  let arr=rem.Data.Table;
				  let art=rem.Data.Table1;
				  //如果父项存在
				  if(art.length>0){
					  //如果类存在
					if(arr.length>0){
				  }else{
					let pop={
					v_str_AccountID: this.v_str_AccountID,
					jsSQL: "{\"SQL\":[{\"insert\":\"insert into YP_module (FProjectID,FName,FParentID) values( '"+this.projectID+"','"+item.FName+"','"+art[0].FItemID+"') \"}]}"
				  }
				  //不存在进行插入
				  let restu=await login(pop)
                    
				   let mom={
					v_str_AccountID: this.v_str_AccountID,
					jsSQL: "{\"SQL\":[{\"select\":\"select * from  YP_module where FProjectID='"+this.projectID+"'and FName='"+item.FName+"'    \"}]}"
				  }
				  //查询刚插入的子项ID
				  let selectdu=await login(mom)
				  let IDTR=selectdu.Data.Table[0].FItemID;

				    let pip={
					v_str_AccountID: this.v_str_AccountID,
					jsSQL: "{\"SQL\":[{\"insert\":\"insert into YP_module (FProjectID,FParentID,FName)select '"+this.projectID+"','"+IDTR+"' , FName from  YP_module where  FParentID ='"+item.FItemID+"' \"}]}"
				  }
				  //插入的子项下的2级子项
				 let int=await login(pip)
				  }
				  }else{
					  //插入父项
					  let pop={
					v_str_AccountID: this.v_str_AccountID,
					jsSQL: "{\"SQL\":[{\"insert\":\"insert into YP_module (FProjectID,FParentID,FName) select  '"+this.projectID+"','0',FName from YP_module where FItemID= '"+item.FParentID+"'  \"}]}"
		          }
				  let restu=await login(pop)
				  if(restu.Result=='Y'){
					  let pp={
					v_str_AccountID: this.v_str_AccountID,
					jsSQL: "{\"SQL\":[{\"select\":\"select * from YP_module where  FProjectID='"+this.projectID+"' and FName =(select FName from YP_module where FItemID= '"+item.FParentID+"') \"}]}"
				  }
				  //查询父项ID
				  let restuli=await login(pp)
				  let amo=restuli.Data.Table
				     let pmp={
					v_str_AccountID: this.v_str_AccountID,
					jsSQL: "{\"SQL\":[{\"insert\":\"insert into YP_module (FProjectID,FParentID,FName)values ('"+this.projectID+"','"+amo[0].FItemID+"','"+item.FName+"')    \"}]}"
				  }
				  //插入子项
				  let rtu= await login(pmp)
				  console.log(rtu)
				  let mom={
					v_str_AccountID: this.v_str_AccountID,
					jsSQL: "{\"SQL\":[{\"select\":\"select * from  YP_module where FProjectID='"+this.projectID+"'and FName='"+item.FName+"'    \"}]}"
				  }
				  //同第一循环
				  let selectdu=await login(mom)
				  let IDTR=selectdu.Data.Table[0].FItemID;
				  let pip={
					v_str_AccountID: this.v_str_AccountID,
					jsSQL: "{\"SQL\":[{\"insert\":\"insert into YP_module (FProjectID,FParentID,FName)select '"+this.projectID+"','"+IDTR+"' ,  FName from  YP_module where  FParentID ='"+item.FItemID+"' \"}]}"
				  }
				   let int=await login(pip)
				}
				}
				   console.log(arr,art)
			}
			}
		 this.nodedata.childNodes = [] 
		 this.loadNode(this.nodedata,this.resolvedata)
         console.log(Data)
	     this.dialogFormVisible=false;
},
			append(data) {
				let ID=this.projectID
				//console.log(data)
              this.$prompt('请输入名称', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				}).then(({ value }) => {
					console.log(value )
				let phems = {
				v_str_AccountID: this.v_str_AccountID,
				jsSQL: "{\"SQL\":[{\"insert\":\"insert into  YP_module (FName, FParentID, FProjectID) VALUES ('"+value+"', '"+data.FItemID+"', '"+ID+"')\"}]}"
				}
				login(phems).then(data => {
				
                    if(data.Result =='Y'){
						this.$message({
							type: 'success',
							message: '新增成功'
						});
						let atu=[];
						console.log(this.nodedata)
						this.nodedata.childNodes = [] 
						this.loadNode(this.nodedata,this.resolvedata)
					}else{
						this.$message({
							type: 'error',
							message: '新增失败'
						});
					}
				})
			 }).catch(() => {
				this.$message({
					type: 'info',
					message: '取消输入'
				});       
				});
      },
			Changetable(row,index){
				let obj = this.itemdate.find(function (e) {
				    return e.FItemID=== row.Characteristic
			    })
			//	console.log(obj,row,index,this.listSData)
				if(this.check==true){
					this.listSData[index].Actual=obj.FName
					this.listSData.forEach((item,index) =>{
						if(index==this.listSData.length-1){
							if(item.Actual!=''){
								this.listSData.push({
									Characteristic:'',
									Actual:'',
									Nominal:''
								})
							}
						}
					})
				}else{
					this.$message({
						type: 'error',
						message: '请选择模块'
					});
				}
			},
			naadd(){
				this.listSData.push({
					Characteristic:'',
					Actual:'',
					Nominal:''
				})
			},
			giveCharData1(index) {
				if (this.currentSorts === index) {
					return false;
				}
				console.log(this.currentSorts,index)
				this.currentSorts = index;
			},
			checkBox(){
				let checkdata=this.$refs.lazytree.getCheckedNodes();
				let arr=[]
				this.removeByValue(checkdata,undefined)
				console.log(checkdata)
				this.checktreedata=checkdata
                checkdata.forEach(item=>{
					if(item.children==undefined){
						arr.push(item)
					}
				})
                this.ctreedata=arr
				let apo=JSON.parse(JSON.stringify(arr));
				apo.unshift({
					FItemID:'all',
					FName:'全部'
				})
				this.ctreesdata=apo
				this.getlistdata();
			},
			removeByValue(arr,val){
				for(let  i=0;i<arr.length;i++){
					if(arr[i]==val){
						arr.splice(i,1)
						break
					}
				}
			},
			reupdate(node,data){
				console.log(node,data)
				let ID=this.projectID
				console.log(ID)
              this.$prompt('请输入修改后的名称', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				}).then(({ value }) => {
					//console.log(value )
				let phems = {
				v_str_AccountID: this.v_str_AccountID,
				jsSQL: "{\"SQL\":[{\"update\":\"update  YP_module set FName='"+value+"' where FItemID='"+data.FItemID+"'\"}]}"
				}
				login(phems).then(data => {
				
                    if(data.Result =='Y'){
						this.$message({
							type: 'success',
							message: '修改成功'
						});
						let atu=[];
						//console.log(this.nodedata)
						this.nodedata.childNodes = [] 
						this.loadNode(this.nodedata,this.resolvedata)
					}else{
						this.$message({
							type: 'error',
							message: '修改失败'
						});
					}
				})
			 }).catch(() => {
				this.$message({
					type: 'info',
					message: '取消修改'
				});       
				});
			},
			remove(node,datam){
                  if(datam.children==undefined){
					  console.log(datam,datam.FItemID)
                      let phems = {
				v_str_AccountID: this.v_str_AccountID,
				jsSQL: "{\"SQL\":[{\"select\":\"select * from YP_budget where LModuleID='"+datam.FItemID+"'\"}]}"
				}
				login(phems).then(data => {
					let arr=data.Data.Table
					if(arr.length>0){
						this.$message({
							type: 'error',
							message: '当前模快下有数据存在，不能删除'
						});
					}else{
						let dele = {
				v_str_AccountID: this.v_str_AccountID,
				jsSQL: "{\"SQL\":[{\"delete\":\"delete from YP_module where FItemID='"+datam.FItemID+"'\"}]}"
				}
				login(dele).then(res => {
                       if(res.Result=='Y'){
						   this.$message({
							type: 'success',
							message: '删除成功'
						});
						this.nodedata.childNodes = [] 
						this.loadNode(this.nodedata,this.resolvedata)
					   }
				})
			    }
				})
				  }else{
                    this.$message({
							type: 'error',
							message: '当前模快下有下级模快存在，不能删除'
						});
				  }
			},
			getlistdata(){
				let ID='';
				this.checktreedata.forEach( (item,index) =>{
                  if(index!=this.checktreedata.length-1){
					  ID+="'"+item.FItemID+"' ,"
				  }else{
					  ID+="'"+item.FItemID+"'"
				  }
				})
				let phems = {
					v_str_AccountID: this.v_str_AccountID,
						jsSQL: "{\"SQL\":[{\"select\":\"select * from  v_modulebud  where LModuleID in ("+ID+")\"}]}"
				}
				login(phems).then(data => {
					let  arr = data.Data.Table 
					this.listData=arr
				})
			},
			handleSizeChange(val) {
				this.pagesize = val;
			},
			handleCurrentChange(val) {
				this.currentPage = val;
			},
			navMenuInsert(){
				 let ID=this.projectID,arr='';
				this.$prompt('请输入名称', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				}).then(({ value }) => {
				let phems = {
				v_str_AccountID: this.v_str_AccountID,
				jsSQL: "{\"SQL\":[{\"insert\":\"insert into  YP_module (FName, FParentID, FProjectID) VALUES ('"+value+"', '0', '"+ID+"')\"}]}"
				}
				login(phems).then(data => {
                    if(data.Result =='Y'){
						this.$message({
							type: 'success',
							message: '新增成功'
						});
						let atu=[];
						console.log(this.nodedata)
						this.nodedata.childNodes = [] 
						this.loadNode(this.nodedata,this.resolvedata)
					}else{
						this.$message({
							type: 'error',
							message: '新增失败'
						});
					}
				})
			 }).catch(() => {
				this.$message({
					type: 'info',
					message: '取消输入'
				});       
				});
			},
		async	insert(){
			   let values='';
			  // if()
			   this.listSData.forEach((item,index)=>{
				   if(item.Actual!=''){
                     if(index!='0'){
                     values+=","+"( '"+item.Actual+"' ,"+"'"+item.Nominal+"',"+"'"+this.treeID+"')"
				     }else{
					   values+="( '"+item.Actual+"' ,"+"'"+item.Nominal+"',"+"'"+this.treeID+"')"
				     }
				   }
			   })
			    let mpo= {
				 	v_str_AccountID: this.v_str_AccountID,
				 	jsSQL: "{\"SQL\":[{\"select\":\"select * from  v_modulebud  where LModuleID in ("+this.treeID+")\"}]}"
				 }
				 let rem =await login(mpo)
				 if(rem.Data.Table.length==0 ||rem.Data.Table[0].FStatus=='0' ){
					  let phems = {
					'v_str_AccountID': this.v_str_AccountID,
					'jsSQL': "{\"SQL\":[{\"sql\":\" insert into YP_budget (LName,LMoney,LModuleID) values "+values+";\"}]}"
				}
				if(this.treeID!=''){
                  login(phems).then(data => {
					if(data.Result=='Y'){
					this.$message({
					type: 'success',
					message: '保存成功'
					});
					let upd= {
					'v_str_AccountID': this.v_str_AccountID,
					'jsSQL': "{\"SQL\":[{\"sql\":\" update YP_module set FSumMoney=(select sum(LMoney) from YP_budget where LModuleID='"+this.treeID+"') where FItemID='"+this.treeID+"' \"}]}"
					 }
					 login(upd).then(res => {
                        console.log(res)
					 })
					this.getlistdata()
					}
				})
				}else{
					this.$message({
					type: 'error',
					message: '请选择保存进的模快'
					});
				}

				 }else{
					 this.$message({
					type: 'warning',
					message: '该模快已经审核，无法在添加'
					});
				 }	
			},
			status(){
				//console.log(this.treesID,this.ctreesdata)
				let upd;
				if(this.treesID=="all"){
					let FID='';
				    this.ctreedata.forEach((item,index)=>{
                        if(index==this.ctreedata.length-1){
                              FID+="'"+item.FItemID+"'"
						}else{
                              FID+="'"+item.FItemID+"',"
						}
				 })
				 upd= {
					'v_str_AccountID': this.v_str_AccountID,
					'jsSQL': "{\"SQL\":[{\"sql\":\" update YP_module set FStatus='1' where FItemID in ("+FID+")\"}]}"
				}
				}else{
				   upd= {
					'v_str_AccountID': this.v_str_AccountID,
					'jsSQL': "{\"SQL\":[{\"sql\":\" update YP_module set FStatus='1' where FItemID='"+this.treesID+"' \"}]}"
					 }
				}
				login(upd).then(res => {
					if(res.Result=='Y'){
						this.$message({
							type: 'success',
							message: '审核成功'
							});
							this.getlistdata()
					   }
				})	
			},
			unstatus(){
				let upd;
				if(this.treesID=="all"){
					let FID='';
				    this.ctreedata.forEach((item,index)=>{
                        if(index==this.ctreedata.length-1){
                              FID+="'"+item.FItemID+"'"
						}else{
                              FID+="'"+item.FItemID+"',"
						}
				 })
				 upd= {
					'v_str_AccountID': this.v_str_AccountID,
					'jsSQL': "{\"SQL\":[{\"sql\":\" update YP_module set FStatus='0' where FItemID in ("+FID+")\"}]}"
				}

				}else{
				   upd= {
					'v_str_AccountID': this.v_str_AccountID,
					'jsSQL': "{\"SQL\":[{\"sql\":\" update YP_module set FStatus='0' where FItemID='"+this.treesID+"' \"}]}"
					 }
				}
				login(upd).then(res => {
					if(res.Result=='Y'){
						this.$message({
							type: 'success',
							message: '反审核成功'
							});
							this.getlistdata()
					   }
				})
			},
			spear(row,type){
				if(type==1){
					this.$confirm('此操作将修改' + row.LName + '数据, 是否继续?', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
					     let upd= {
					'v_str_AccountID': this.v_str_AccountID,
					'jsSQL': "{\"SQL\":[{\"sql\":\" update YP_budget set LName='"+row.LName+"',LMoney='"+row.LMoney+"'  where LItemID='"+row.LItemID+"' \"}]}"
					 }
					 login(upd).then(res => {
                       if(res.Result=='Y'){
							this.$message({
							type: 'success',
							message: '修改成功'
							});
							this.getlistdata()
					   }
					 })
						}).catch(() => {
							this.$message({
								type: 'info',
								message: '已取消修改'
							});
						});
				}else{
					  this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
           let delt= {
					'v_str_AccountID': this.v_str_AccountID,
					'jsSQL': "{\"SQL\":[{\"sql\":\" delete from YP_budget   where LItemID='"+row.LItemID+"' \"}]}"
					 }
					 login(delt).then(res => {
                       if(res.Result=='Y'){
							this.$message({
							type: 'success',
							message: '修改成功'
							});
							this.getlistdata()
					   }
					 })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
		}	
		},
			getdata(){
				let arr;
				let phems = {
					'v_str_AccountID': this.v_str_AccountID,
					'jsSQL': "{\"SQL\":[{\"select\":\"  select * from  t_Item  where FItemClassID='3005'\"}]}"
				}
				login(phems).then(data => {
						 arr = data.Data.Table
						 	console.log(arr)
				let treedata=new Array()
				let att=this.convert(arr)
				this.treeData=att
				})
			
			},
			convert(list) {
			    let res = []
			    let maps = list.reduce((pre, cur) => { pre[cur.FItemID] = cur; return pre }, {}) 
			    // let maps = new Map(Array.from(list, (x) => [x.id, x])) 
			    for(let i = 0, len = list.length; i < len; i++ ) {
			        let item = list[i]
					item['label']=item['FName']
					item['name']=item['FName']
					item['id']=item['FItemID']
			        if(item.FParentID === 0) {
			            res.push(item)
			        } else {
			        let parent = maps[item.FParentID]
			        // let parent = maps.get(item.parentId)
			  	//	console.log(parent)
			        if (parent) {
			          (parent.children || (parent.children = [])).push(item);
			        }
			        }
			    }
			 return res
			},
			convertt(list) {
			   let res = []
			     let maps = list.reduce((pre, cur) => { pre[cur.FItemID] = cur; return pre }, {}) 
			     // let maps = new Map(Array.from(list, (x) => [x.id, x])) 
			     for(let i = 0, len = list.length; i < len; i++ ) {
			         let item = list[i]
			         if(item.FParentID === 0){
			             res.push(item)
			         } else {
			             let parent = maps[item.FParentID]
			             // let parent = maps.get(item.parentId)
						 //console.log(parent)
			         if (parent) {
			           (parent.children || (parent.children = [])).push(item);
			         }
			         }
			     }
			     return res
			},
			navMenuOK(){
				let LName=this.addform.LName,LItemID=this.addform.LItemID,ID=this.projectID
				let that=this
				let phems = {
						v_str_AccountID: this.v_str_AccountID,
						jsSQL: "{\"SQL\":[{\"insert\":\"insert into  YP_module (FName, FParentID, FProjectID) VALUES ('"+LName+"', '"+LItemID+"', '"+ID+"')\"}]}"
				}
				login(phems).then(data => {
                    if(data.Result =='Y'){
						that.$message({
							type: 'success',
							message: '新增成功'
						});
						let atu=[];
						console.log(that.nodedata)
						that.nodedata.childNodes = [] 
						that.loadNode(that.nodedata,that.resolvedata)
					}else{
						that.$message({
							type: 'error',
							message: '新增失败'
						});
					}
				})
				this.navMenuAdd=false
			},
			  handleCheckChange(data, checked, indeterminate) {
			      //   console.log(data, checked, indeterminate);
					 this.check=checked
			  },
			  handleNodeClick(data) {
			        // console.log(data);
				   },
				sumArr(arr){
				var sum = 0
				arr.forEach(item => {
					if(item.children) {
						sum += this.sumArr(item.children); //递归去处理数组元素
					} else {
						//if(typeof item =="number"){
						sum+=Number(item.FSumMoney)
						//}  
					}
				})
				return sum
				},
			  loadNode(node, resolve,tu) {
					let ID=this.projectID,arr='';
					let phems = {
					'v_str_AccountID': this.v_str_AccountID,
					'jsSQL': "{\"SQL\":[{\"select\":\"  select * from  YP_module  where FProjectID='"+ID+"'\"}]}"
				}
				login(phems).then(data => {
					arr = data.Data.Table
					arr.forEach(item =>{
						// if(item.FSumMoney==''||item.FSumMoney==null){
						// 	item.FSumMoney='0'
						// }
						item['name']=item['FName']
						//+' '+'('+item.FSumMoney+')'
					})
					let att=this.convertt(arr)
					// att.forEach(item =>{
					// 	let o=[];
					// 	o.push(item)
					//   let appo=this.sumArr(o)
					//   item['name']=item.name+'('+appo+')'
					// })
					console.log(att)
					if (node.level === 0) {
					this.nodedata=node,
					this.resolvedata=resolve
					return resolve(att);
				}
			    setTimeout(() => {
			       var data;
					   if(node.data.children){
						   data=node.data.children
					   }else{
						   data=[]
					   } resolve(data);
			      }, 500);
				})
			},
			nodeClick(e){
				console.log(e)
				this.projectID=e.FItemID
				if(e.children==undefined){
					this.showtable=true
				}else{
					this.$message({
						type: 'error',
						message: '当前项目不是末级，请检查'
					});
					this.showtable=false
				}
				if(this.nodedata!=''){
						this.nodedata.childNodes = [] ;
						this.loadNode(this.nodedata,this.resolvedata)
				}
				let arr,that=this;
				let phems = {
				'v_str_AccountID': this.v_str_AccountID,
				'jsSQL': "{\"SQL\":[{\"select\":\"  select * from  t_Item  where FItemClassID='4'\"}]}"
			    }
				login(phems).then(data => {
			   arr = data.Data.Table
			   this.ctreedata=[]
							  that.loading = false
							  that.itemdate=arr

							  that.listSData=[{
							  	Characteristic:'',
							  	Actual:'',
							  	Nominal:''
							  }]
				})
				
					
				},
		},
}
</script>

<style>
		.demo-ruleForm>>>.el-input {
		    width: 100%;
		    margin-right: 10px;
		}
		.demo-ruleForm>>>.el-input__inner {
			border: 0;
			background-color:
				#FFF;
			color: #606266;
			/*text-align: center;*/
		}
		.el-button+.el-button, .el-checkbox.is-bordered+.el-checkbox.is-bordered{
			margin-left: 0px
		}
		 .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
</style>

 


// WEBPACK FOOTER //
// src/views/druid/login.vue